// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ZI6z","requiredAsterisk":"Info_requiredAsterisk__27v7E"};